import { FC } from 'react'

import { Button } from '@trustycars/genie-ui/components'
import { propsWithClassNames } from '@trustycars/genie-ui/functions'

import useOTPBlock from '$actions/useOTPBlock'

import {
  description as descriptionStyle,
  header,
  title as titleStyle
} from '$blocks/common/auth.css'
import OTPInput from '$elements/OTPInput'
import VirtualOTPForm from '$elements/VirtualOTPForm'

import { otp } from './styles.css'

export type OTPBlockProps = ReturnType<typeof useOTPBlock>

export const OTPBlock: FC<OTPBlockProps> = ({
  otpInput,
  refCode,
  onResend,
  timerActive,
  timerSeconds,
  title,
  description
}) => {
  const otpInputProps = {
    ...otpInput,
    passwordFieldProps: {
      ...otpInput.passwordFieldProps,
      inputProps: propsWithClassNames(
        otpInput.passwordFieldProps.inputProps,
        otp.input
      )
    }
  }

  return (
    <>
      <header className={header}>
        <h2 className={titleStyle}>{title}</h2>

        <p className={descriptionStyle}>{description}</p>
      </header>

      <main className={otp.main}>
        <VirtualOTPForm>
          <OTPInput autoFocus {...otpInputProps} />
        </VirtualOTPForm>

        <div className={otp.actions}>
          {timerActive ? (
            <p className={otp.reSendText}>
              Resend in{' '}
              <span className={otp.highlightedText}>{timerSeconds}s</span>
            </p>
          ) : (
            <Button
              className={otp.resendButton}
              styleVariants={{ size: 'small' }}
              onClick={onResend}
              disabled={otpInput.disabled}
            >
              Resend OTP
            </Button>
          )}

          {refCode && (
            <p className={otp.refCodeText}>
              Ref: (<span className={otp.highlightedText}>{refCode}</span>)
            </p>
          )}
        </div>
      </main>
    </>
  )
}

export default OTPBlock
